"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PropertyTypes = require("../PropertyTypes");

var _ExternalOptionTypes = require("../ExternalOptionTypes");

var _PropertyFieldTypes = require("../PropertyFieldTypes");

var _PropertyRecord = _interopRequireDefault(require("../PropertyRecord"));

var _default = (0, _PropertyRecord.default)({
  displayOrder: -1,
  externalOptions: true,
  favoritedOrder: -1,
  fieldType: _PropertyFieldTypes.RADIO,
  formField: true,
  groupName: 'contactinformation',
  hidden: false,
  hubspotDefined: true,
  label: 'Import',
  name: '_inbounddbio.importid_',
  readOnlyDefinition: true,
  readOnlyValue: true,
  referencedObjectType: _ExternalOptionTypes.INBOUND_DB_IMPORT,
  type: _PropertyTypes.ENUMERATION
});

exports.default = _default;
module.exports = exports.default;